const types = {
    MEMBERINFO_NUM: 'MEMBERINFO_NUM', // fkMemberMultiId
    MEMBERINFO_MAINPK: 'MEMBERINFO_MAINPK',
    MEMBERINFO_ACCOUNT: 'MEMBERINFO_ACCOUNT',
    MEMBERINFO_GAMEACCOUNT: 'MEMBERINFO_GAMEACCOUNT',
    MEMBERINFO_CONSIGNEECODE: 'MEMBERINFO_CONSIGNEECODE',
    MEMBERINFO_EMAIL: 'MEMBERINFO_EMAIL'
}


const state = {
    num: "",
    mainPk: "",
    account: "",
    gameAccount: "",
    consigneeCode: "",
    email: ""
}


const getters = {
    getNum: state => state.num,
    getMainPk: state => state.mainPk,
    getAccount: state => state.account,
    getGameAccount: state => state.gameAccount,
    getConsigneeCode: state => state.consigneeCode,
    getEmail: state => state.email
}


const actions = {
    actionSetNum({ commit }, num) {
        commit(types.MEMBERINFO_NUM, num);
    },
    actionSetMainPk({ commit }, mainPk) {
        commit(types.MEMBERINFO_MAINPK, mainPk)
    },
    actionSetAccount({ commit }, account) {
        commit(types.MEMBERINFO_ACCOUNT, account)
    },
    actionSetGameAccount({ commit }, gameAccount) {
        commit(types.MEMBERINFO_GAMEACCOUNT, gameAccount)
    },
    actionSetConsigneeCode({ commit }, consigneeCode) {
        commit(types.MEMBERINFO_CONSIGNEECODE, consigneeCode)
    },
    actionSetEmail({ commit }, email) {
        commit(types.MEMBERINFO_EMAIL, email)
    }
}


const mutations = {
    [types.MEMBERINFO_NUM](state, num) {
        state.num = num;
    },
    [types.MEMBERINFO_MAINPK](state, mainPk) {
        state.mainPk = mainPk;
    },
    [types.MEMBERINFO_ACCOUNT](state, account) {
        state.account = account;
    },
    [types.MEMBERINFO_GAMEACCOUNT](state, gameAccount) {
        state.gameAccount = gameAccount;
    },
    [types.MEMBERINFO_CONSIGNEECODE](state, consigneeCode) {
        state.consigneeCode = consigneeCode;
    },
    [types.MEMBERINFO_EMAIL](state, email) {
        state.email = email;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}